import React, {memo, useState, useEffect} from "react"
import {useHistory} from "react-router"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import "./index.scss"

export const ScreenCleanerScreen = memo(function ScreenCleanerScreen() {
    const history = useHistory()
    const [timeValue, setTimeValue] = useState(60)
    useEffect(() => {
        let time = timeValue
        const timer = setInterval(() => {
            time--
            if (time >= 1) {
                setTimeValue(time)
            } else {
                history.push("/settings")
            }
        }, 1000)
        return () => clearInterval(timer)
    }, [history, timeValue])
    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <div className="screen-cleaner-overlay">
                <span>{timeValue}</span>
                <span>inohom</span>
            </div>
        </PasswordContainer>
    )
})
